import React from "react";
import classNames from "classnames";
import * as styles from "./styles.module.scss";
const CompletenessIndicator = ({ complete, fullHeight = false, tiny = false, className }) => (React.createElement("div", { className: classNames(styles.indicator, className, {
        [styles["full-height"]]: fullHeight,
        [styles.tiny]: tiny,
        [styles.complete]: complete,
    }) }));
export default CompletenessIndicator;
